var FakeBackendInterceptor = function FakeBackendInterceptor(adapter) {
  adapter.onAny().passThrough();
};

export { FakeBackendInterceptor };